import axios from "axios";
import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


const LoginContext = createContext()

export const LoginProvider = ({ children }) => {
    const [isLogiPopupOpen, setIsLoginPopupOpen] = useState(false)
    const [isAuthenticated, setIsAuthenticated] = useState(false)

    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    // const API_BASE = "https://api.1000siljang.xyz/api/users";

    const openLoginPopup = () => { setIsLoginPopupOpen(true) }
    const closeLoginPopup = () => { setIsLoginPopupOpen(false) }

    const login = async (username, password) => {
        setLoading(true);
        setError(null);
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/api/users/login`,
                {
                    "username": username,
                    "password": password
                },
                {
                    headers: {
                        "accept": "application/json",
                        "Content-Type": "application/json",
                        // "X-CSRFTOKEN": "EdK5PAvTRvWEyRdfznMVSS44tKmYub0PIcqlchfULJqZ07LYacmeBe8iWH3MYOQQ"
                    },
                }
            );
            // console.log("Login response:", res.data);
            setUser(res.data.user);
            setToken(res.data.token);
            localStorage.setItem("nrt_Korean_user", JSON.stringify(res.data.user)); // temporarily storing user in localStorage
            localStorage.setItem("nrt_Korean_token", JSON.stringify(res.data.token)); // temporarily storing token in localStorage
            setIsAuthenticated(true);
            closeLoginPopup();
        } catch (err) {
            console.error("Login error:", err);
            setError("Login failed. Please check credentials.");
        } finally {
            setLoading(false);
        }
    };

    const signup = async (formData) => {
        setLoading(true);
        setError(null);
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/api/users/signup`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRFTOKEN": "EdK5PAvTRvWEyRdfznMVSS44tKmYub0PIcqlchfULJqZ07LYacmeBe8iWH3MYOQQ"
                    },
                    withCredentials: true
                }
            );
            console.log("Signup response:", res.data);
            // optionally auto-login after signup
            setUser(res.data);
            setIsAuthenticated(true);
        } catch (err) {
            console.error("Signup error:", err);
            setError("Signup failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const logout = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}/api/users/logout`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": token?.token ? `Bearer ${token.token}` : "",

                    },
                }
            );

            if (!response.ok) {
                const errorData = await response.json();
                console.error("Logout error:", errorData);
                // setError("Logout failed.");
            }
            setUser(null);
            setToken(null);
            localStorage.removeItem("nrt_Korean_user");
            localStorage.removeItem("nrt_Korean_token");
            setIsAuthenticated(false);
            navigate("/");
        } catch (err) {
            console.error("Logout error:", err.response ? err.response.data : err);
            // setError("Logout failed.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        try {
            const savedUser = localStorage.getItem("nrt_Korean_user");
            const savedToken = localStorage.getItem("nrt_Korean_token");

            if (savedUser && savedToken) {
                const parsedUser = JSON.parse(savedUser);
                const parsedToken = JSON.parse(savedToken);

                const now = new Date();
                const expiresAt = new Date(parsedToken.expires_at);
                // console.log("Expires at:", expiresAt);
                // console.log(" now:", now);

                if (now < expiresAt) {
                    console.log("Session restored from localStorage");
                    setUser(parsedUser);
                    setToken(parsedToken);
                    setIsAuthenticated(true);


                } else {
                    console.log("Token expired, logging out.");

                    logout();
                }
            }
        } catch (e) {
            console.error("Error restoring session from localStorage:", e);
        }
    }, []);


    return (
        <>
            <LoginContext.Provider value={{
                isLogiPopupOpen,
                openLoginPopup,
                closeLoginPopup,
                isAuthenticated,
                login,
                logout,
                signup,
                user,
                token,
                error,
                loading,
            }} >
                {children}
            </LoginContext.Provider>
        </>
    )
}
export default LoginContext